export const AUTH_NAVIGATION_STATE_KEYS = {
    REDIRECT_TO: 'redirectTo',
} as const;
  
export const AUTH_PROVIDER_ID = {
    GOOGLE: 'google.com',
    FACEBOOK: 'facebook.com',
} as const;
  
export const POST_LOGIN_DECISION_KIND = {
    ONBOARDING: 'onboarding',
    ROUTE: 'route',
  } as const;
  
export type PostLoginDecisionKind = 
    (typeof POST_LOGIN_DECISION_KIND)[keyof typeof POST_LOGIN_DECISION_KIND];

export const REDIRECT_SAFETY = {
    PATH_ROOT_PREFIX: '/',
    PATH_PROTOCOL_RELATIVE_PREFIX: '//',
    PROTOCOL_SEPARATOR: '://',
} as const;
  
  